import React from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
export const MeetCenia = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].meet;
  return <FadeInSection id="about" className="w-full bg-[#f8f4ef]" data-id="element-169" data-mp="3jqyt8ju69bo1">
      <div className="flex flex-col lg:flex-row w-full min-h-[800px]" data-id="element-170" data-mp="3omnl00zy9o9s">
        {/* Left: Image */}
        <div className="w-full lg:w-1/2 h-[500px] lg:h-auto relative" data-id="element-171" data-mp="2r1i53ydl4gxm">
          <img src="https://cdn.magicpatterns.com/uploads/5VnyT84TQYuMgcqFXXF2nk/Cenia_centrada.png" alt="Cenia Badillo" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-172" data-mp="2vyrsl8heyiit" />
        </div>

        {/* Right: Content */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center px-8 py-20 lg:px-24 xl:px-32" data-id="element-173" data-mp="g85h8bh1kuvz">
          <span className="eyebrow mb-4" data-id="element-174" data-mp="k9h100d8ilw9">{t.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl uppercase tracking-wider text-[#1a1a1a] mb-8" data-id="element-175" data-mp="k7xjy7jr86tf">
            {t.headline}
          </h2>

          <div className="w-[60px] h-px bg-[#c9a96e] mb-10" data-id="element-176" data-mp="3sf6ysni8ceg7" />

          <div className="space-y-8" data-id="element-177" data-mp="3sdm5f17nj1jx">
            <p className="body-text text-lg text-[#1a1a1a]/80" data-id="element-178" data-mp="3ng2lbko9vuk2">{t.body1}</p>
            <p className="body-text text-lg text-[#1a1a1a]/60 italic font-light" data-id="element-179" data-mp="3jf0mh4y9pkim">
              {t.body2}
            </p>
          </div>

          <div className="mt-12" data-id="element-180" data-mp="3egz30iwxjj6m">
            <button onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} className="px-10 py-4 border border-[#c9a96e] text-[#c9a96e] uppercase tracking-widest text-sm hover:bg-[#c9a96e] hover:text-white transition-colors duration-300" data-id="element-181" data-mp="3ei0geu1f4hri">
              {t.cta}
            </button>
          </div>
        </div>
      </div>
    </FadeInSection>;
};